import { roundWithTaxPercent } from 'Helpers/utils';

export const getProductFromTemplateItem = (templateItem, taxPercent) => {
  return {
    ottersgProductId: templateItem.inventoryItemId,
    description: {
      name: templateItem.name,
      unitPrice: roundWithTaxPercent(templateItem.unitPrice, taxPercent),
      unitPriceBeforeTax: templateItem.unitPrice,
    },
    quantity: templateItem.quantity,
    amountPerTime: templateItem.dose || '',
    frequency: templateItem.sddFrequencyDescription || '',
    frequencyCode: templateItem.frequency || '',
    note: templateItem.note || '',
    doseUnit: templateItem.sddDoseUnitDescription || '',
    doseUnitCode: templateItem.doseUnit || '',
    useCustomInstruction: false,
    uom: templateItem.uomDescription,
    uomUnit: templateItem.uomDescription || '',
    uomCode: templateItem.uom,
    route: templateItem.sddRouteDescription,
    routeCode: templateItem.route,
    unitPrice: roundWithTaxPercent(templateItem.unitPrice, taxPercent),
    duration: templateItem.duration,
    durationUnit: templateItem.durationUnitDescription,
    durationUnitCode: templateItem.durationUnit,
  };
};
